import {
  menuComponent,
  menuProps
} from './menuModule'
// 生成路由数据
export function getRouters (data) {
  let routersList = [{
    id: 0,
    path: '/',
    name: 'ProjectFrame',
    component: 'ProjectFrame/Index',
    children: changeRoutersData(data)
  }]
  const routers = []
  routersList.forEach(item => {
    const menu = {}
    menu.path = item.path
    menu.name = item.name
    if (item.redirect) {
      menu.redirect = item.redirect
    }
    if (item.title) {
      menu.meta = {
        title: item.title,
        icon: item.icon,
        notrequireAuth: false,
        id: String(item.id),
        parentId: String(item.parentId),
        permission: item.permission
      }
    }
    menu.component = menuComponent(item.component)
    if (item.props) {
      menu.props = menuProps(item.props)
    }
    menu.children = []
    subRouters(menu, item.children)
    routers.push(menu)
  })
  const view404 = {
    path: '*',
    redirect: '/404',
    hidden: true
  }
  routers.push(view404)
  return routers
}

function subRouters (parent, data) {
  data.forEach(item => {
    const submenu = {}
    submenu.component = menuComponent(item.component)
    if (item.props) {
      submenu.props = menuProps(item.props.split(','))
    }
    submenu.meta = {
      title: item.title,
      icon: item.icon,
      notrequireAuth: false,
      id: String(item.id),
      parentId: String(item.parentId),
      permission: item.permission
    }
    submenu.path = item.path
    submenu.name = item.name
    parent.children.push(submenu)
    if (item.children && item.children.length > 0) {
      submenu.children = []
      subRouters(submenu, item.children)
    }
  })
}

// 菜单展开
function changeRoutersData (data) {
  let routers = []
  data.forEach(item => {
    let temp = {...item}
    // temp.children = []
    // routers.push(temp)
    if (item.children && item.children.length > 0) {
      routers = [...changeRoutersData(item.children), ...routers]
    } else {
      routers.push(temp)
    }
  })
  return routers
}



// WEBPACK FOOTER //
// ./src/utils/menu.js